import React, { ReactNode } from 'react';
import { ModalsKeys } from 'global';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { SearchInventoryDialog } from 'modules/inventory';

import { ApiContainer } from '../api';
import { PageFallback } from './PageFallback';
import { SendApplicationForm } from './sendApplicationForm';

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.SearchInventoryDialog]: <SearchInventoryDialog />,
};

export const SendCreditApplicationPage = () => {
  return (
    <PageContainer modals={modalsWithKeys} title="Send Application">
      <CardContainer>
        <ApiContainer>
          {({ isDataLoading, handleSendOcaLink, ...rest }) => (
            <RenderWithFallback isLoading={isDataLoading} fallBack={<PageFallback />}>
              <SendApplicationForm onSendOcaLink={handleSendOcaLink} {...rest} />
            </RenderWithFallback>
          )}
        </ApiContainer>
      </CardContainer>
    </PageContainer>
  );
};
